export default {
  default: {
    container: "w-full bg-paper border border-neutral_2 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-primary",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-primary",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-text mb-1",
    message: "text-sm text-text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-text_secondary hover:text-text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-canvas",
    progressBar: "h-full bg-primary transition-all"
  },

  success: {
    container: "w-full bg-paper border border-success/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-success",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-success",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-text mb-1",
    message: "text-sm text-text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-text_secondary hover:text-text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-success/10",
    progressBar: "h-full bg-success transition-all"
  },

  error: {
    container: "w-full bg-paper border border-error/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-error",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-error",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-text mb-1",
    message: "text-sm text-text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-text_secondary hover:text-text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-error/10",
    progressBar: "h-full bg-error transition-all"
  },

  warning: {
    container: "w-full bg-paper border border-warning/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-warning",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-warning",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-text mb-1",
    message: "text-sm text-text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-text_secondary hover:text-text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-warning/10",
    progressBar: "h-full bg-warning transition-all"
  },

  info: {
    container: "w-full bg-paper border border-info/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-info",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-info",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-text mb-1",
    message: "text-sm text-text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-text_secondary hover:text-text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-info/10",
    progressBar: "h-full bg-info transition-all"
  },

  // Admin theme variants
  admin_default: {
    container: "w-full bg-admin_paper border border-admin_neutral_2 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-admin_primary",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-admin_primary",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-admin_text mb-1",
    message: "text-sm text-admin_text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-admin_text_secondary hover:text-admin_text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-admin_canvas",
    progressBar: "h-full bg-admin_primary transition-all"
  },

  admin_success: {
    container: "w-full bg-admin_paper border border-admin_success/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-admin_success",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-admin_success",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-admin_text mb-1",
    message: "text-sm text-admin_text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-admin_text_secondary hover:text-admin_text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-admin_success/10",
    progressBar: "h-full bg-admin_success transition-all"
  },

  admin_error: {
    container: "w-full bg-admin_paper border border-admin_error/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-admin_error",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-admin_error",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-admin_text mb-1",
    message: "text-sm text-admin_text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-admin_text_secondary hover:text-admin_text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-admin_error/10",
    progressBar: "h-full bg-admin_error transition-all"
  },

  admin_warning: {
    container: "w-full bg-admin_paper border border-admin_warning/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-admin_warning",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-admin_warning",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-admin_text mb-1",
    message: "text-sm text-admin_text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-admin_text_secondary hover:text-admin_text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-admin_warning/10",
    progressBar: "h-full bg-admin_warning transition-all"
  },

  admin_info: {
    container: "w-full bg-admin_paper border border-admin_info/30 rounded-lg shadow-lg overflow-hidden z-[9999]",
    accent: "absolute left-0 top-0 bottom-0 w-1 bg-admin_info",
    content: "flex items-start gap-3 p-4",
    iconContainer: "flex-shrink-0 mt-0.5",
    icon: "w-5 h-5 text-admin_info",
    textContent: "flex-1 min-w-0",
    title: "text-sm font-medium text-admin_text mb-1",
    message: "text-sm text-admin_text_secondary",
    children: "mt-2",
    closeButton: "flex-shrink-0 p-1 text-admin_text_secondary hover:text-admin_text transition-colors",
    closeIcon: "w-4 h-4",
    progressContainer: "absolute bottom-0 left-0 right-0 h-1 bg-admin_info/10",
    progressBar: "h-full bg-admin_info transition-all"
  }
}